import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

const CREATE_EVENT_MUTATION = gql`
  mutation ditCreateEvent(
    $countryIsoCode: String!
    $sourceId: ID!
    $sourceFiles: [SourceFileInput!]!
  ) {
    ditCreateEvent(
      countryIsoCode: $countryIsoCode
      sourceId: $sourceId
      sourceFiles: $sourceFiles
    ) {
      eventId
      presignedUrls
    }
  }
`;

export const useDitCreateEvent = () => {
  const [createEvent, { data, loading, error }] = useMutation(CREATE_EVENT_MUTATION);

  return {
    createDitEvent: async ({ countryIsoCode, sourceId, sourceFiles }) => {
      return await createEvent({
        variables: {
          countryIsoCode,
          sourceId,
          sourceFiles,
        },
      });
    },
    eventData: data?.ditCreateEvent,
    loading,
    error,
  };
};
